//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { filter } from 'lodash';
import { cloneDeep } from 'lodash';

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const phrasesInitial = [];

export const phrases = (state = phrasesInitial, action) => {
  switch (action.type) {
    case ActionTypes.phrases.listPhrasesSuccess:
      return action.payload;
    case ActionTypes.phrases.updatePhrasesSuccess:
      return state.map((x) => {
        if (x.id === action.payload?.id) {
          return { ...x, ...action.payload };
        }
        return x;
      });
    case ActionTypes.phrases.deletePhrasesSuccess:
      const delv = cloneDeep(state);
      const result = filter(delv, (k) => k.id != action.payload.id);
      return result;
    case ActionTypes.phrases.listPhrasesFail:
      return state;
    case ActionTypes.phrases.createPhrasesSuccess:
      return [...state, action.payload];
    default:
      return state;
  }
};
